import { render, staticRenderFns } from "./BeneficiaryBudget.vue?vue&type=template&id=7a84f84e&"
import script from "./BeneficiaryBudget.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports